import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  min-height: 80vh;\n  padding-top: 48px;\n  padding-bottom: 72px;\n  background-color: white;\n  @media (max-width: 1200px) {\n  }\n  @media (max-width: 768px) {\n    padding-bottom: 88px;\n    padding-top: 0;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { View } from "@/components";
import { HandoutProductDetailView } from "@/components/Product/Handout/HandoutProductDetailView";
import TextBanner from "@/components/Product/TextBanner";
import useProductDetailEventTracking from "@/components/Product/useProductDetailEventTracking";
import { ProductDetailView } from "@/modules/products/views/ProductDetailView";
import { buildProductSeo } from "@/lib/seo/buildProductSeo";
import { NextSeo } from "next-seo";
import { useMemo } from "react";
import { isBooksProduct } from "src/api/booksProducts";
import styled from "styled-components";
const ProductDetailPageWrapper = styled(View).withConfig({
    componentId: "sc-25aadc35-0"
})(_templateObject());
const ProductShowNextPage = (param)=>{
    let { product , textBanner , badgeText  } = param;
    const productType = useMemo(()=>isBooksProduct(product) ? product.productType : product.source_type, [
        product
    ]);
    useProductDetailEventTracking(product);
    const metadata = buildProductSeo(product);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(NextSeo, {
                ...metadata
            }),
            textBanner && /*#__PURE__*/ _jsx(TextBanner, {
                textBanner: textBanner,
                subject: product.source.subject
            }),
            /*#__PURE__*/ _jsx(ProductDetailPageWrapper, {
                children: productType === "handout" ? /*#__PURE__*/ _jsx(HandoutProductDetailView, {
                    product: product,
                    badgeText: badgeText
                }) : /*#__PURE__*/ _jsx(ProductDetailView, {
                    product: product
                })
            })
        ]
    });
};
export var __N_SSP = true;
export default ProductShowNextPage;
